









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ClaioSchemaItem } from "../../../../../../domain/claio";
import { IImageDragParameter } from "../../../../../dragging";

@Component({
  components: {
  }
})
export default class ClaioSchemaPreview extends Mixins() {
  @Prop()
  item: ClaioSchemaItem;

  @Prop()
  isFitted: boolean;

  get imageSource(): string {
    if (!this.item) { return null; }
    
    return this.item.imageSource.source;
  }

  onDragStart(event: DragEvent): void {
    const data: IImageDragParameter = {
      isClaioSchema: true,
      claioSchemaDragParameter: {
        schemaTemplateId: this.item.templateId,
        schemaGroupId: this.item.groupId,
        schemaItemId: this.item.itemId,
      }
    };
    const text = JSON.stringify(data);
    // 第一引数(format)が"text"でないとIEでエラーになる。
    event.dataTransfer.setData("text", text);
  }
}
